import { isEmpty } from 'lodash'

export const getPickupForConcessions = (serviceTypeName) => {
  if (isEmpty(serviceTypeName)) return ''

  return serviceTypeName === 'Concessions'
    ? 'Pickup'
    : serviceTypeName
}
